import { useState } from "react";
import { useListProjects } from "@workspace/api-client";
import { SEO } from "@/components/SEO";
import { JsonLd } from "@/components/JsonLd";
import { ProjectCard } from "@/components/common/ProjectCard";

export default function Work() {
  const [activeCategory, setActiveCategory] = useState("All");
  const { data: projectsData, isLoading } = useListProjects();

  const projects = projectsData && projectsData.length > 0 ? projectsData : [];

  const categories = ["All", ...Array.from(new Set(projects.map((p: any) => p.category)))];

  const filteredProjects = activeCategory === "All"
    ? projects
    : projects.filter((p: any) => p.category === activeCategory);

  return (
    <div className="flex flex-col w-full overflow-hidden">
      <SEO
        title="Portfolio | Our Work"
        description="Explore the digital products we've built. From FinTech dashboards to Health & Fitness trackers, we deliver high-performance applications that scale."
      />
      <JsonLd schema={{
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "AccelerateByte Portfolio",
        "url": "https://acceleratebyte.com/work",
        "description": "Digital products we've built — from FinTech dashboards to mobile apps — for high-growth companies worldwide.",
        "itemListElement": projects.map((project: any, i: number) => ({
          "@type": "ListItem",
          "position": i + 1,
          "item": {
            "@type": "CreativeWork",
            "name": project.title,
            "url": `https://acceleratebyte.com/work/${project.slug}`,
            "description": project.description,
            "creator": { "@id": "https://acceleratebyte.com/#organization" }
          }
        }))
      }} />
      <section className="pt-32 pb-16 px-4">
        <div className="container mx-auto text-center max-w-4xl">
          <h1 className="font-display text-5xl md:text-7xl font-bold mb-6 tracking-tight">Our Work</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Products we've built that are generating revenue, securing funding, and scaling businesses.
          </p>
        </div>
      </section>

      <section className="py-8 px-4 container mx-auto">
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat as string)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${activeCategory === cat
                  ? "bg-primary text-primary-foreground shadow-sm"
                  : "bg-muted/50 text-muted-foreground hover:bg-muted"
                }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
          {filteredProjects.map((project: any, i: number) => (
            <ProjectCard key={project.slug} project={project} index={i} />
          ))}
        </div>
      </section>
    </div>
  );
}
